var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 1.49951C14.5004 1.49951 18.25 5.24913 18.25 9.87451C18.25 12.0075 17.4506 13.9525 16.1377 15.4312L22.3535 21.647C22.5481 21.8423 22.5486 22.159 22.3535 22.354C22.1584 22.5488 21.8417 22.5486 21.6465 22.354L15.4307 16.1382C13.9521 17.4506 12.0075 18.2495 9.875 18.2495C5.24962 18.2495 1.5 14.4999 1.5 9.87451C1.5 5.24913 5.24962 1.49951 9.875 1.49951ZM9.875 2.49951C5.8019 2.49951 2.5 5.80141 2.5 9.87451C2.5 13.9476 5.8019 17.2495 9.875 17.2495C13.9481 17.2495 17.25 13.9476 17.25 9.87451C17.25 5.80141 13.9481 2.49951 9.875 2.49951Z",
    fill: "#131616"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;